<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8" md="9" lg="10" v-if="isView">
            <v-text-field
              :disabled="isView"
              label="User Id "
              v-model="selectedUser.user.userId"
            />
          </v-col>
        </v-row>
        <v-row v-if="isView">
          <v-col cols="12" sm="4">
            <!-- <v-select
              v-model="selectedUser.user.email"
              :items="itemsStatus"
              item-value="value"
              item-text="text"
              label="Email"
            ></v-select> -->
            <v-autocomplete
              v-model="selectedUser.supplierInternalId"
              :items="itemsSupplier"
              item-value="internalId"
              item-text="supplierName"
              label="Supplier Name"
              disabled
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="selectedUser.corpUsersId"
              :items="itemsSupplier"
              item-value="internalId"
              item-text="supplierName"
              label="internalId"
            ></v-autocomplete>
          </v-col> -->
          <v-col cols="12" sm="4">
            <v-text-field
              disabled
              label="SupplierId"
              v-model="selectedUser.supplierInternalId"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="User Email"
              v-model="selectedUser.user.email"
              disabled
            />
          </v-col>
        </v-row>

        <v-row v-if="isAdd">
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="selectedUser.userId"
              :items="users"
              item-value="userId"
              :item-text="getUserItemConcatText"
              label="User"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="selectedUser.supplierInternalId"
              :items="itemsSupplier"
              item-value="internalId"
              :item-text="getSupplierItemConcatText"
              label="Supplier Name"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- filter people by location switch -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "../../../api";
export default {
  props: {
    selectedUser: {
      type: Object,
    },
  },
  data() {
    return {
      itemsSupplier: [],
      supplier: {},
      corpUser: {},
      users: [],
      roleItems: [],
      isEdit: false,
      isView: false,
      isAdd: false,
      supplierId: 0,
    };
  },
  mounted() {
    this.isAdd = this.$route.path.includes("add");
    this.isView = this.$route.path.includes("details");
    this.getAllSupliers();
    this.getAllUsers();
  },
  methods: {
    getUserItemConcatText(item) {
      return `${item.userId} - ${item.email} `;
    },
    getSupplierItemConcatText(item) {
      return `${item.internalId} - ${item.supplierName} `;
    },

    async getAllSupliers() {
      this.itemsSupplier = await api.suppliers.getAll();
      this.supplierId = Number(this.selectedUser.supplierId);
    },

    async getAllUsers() {
      try {
        this.loadingUsers = true;
        this.users = await api.users.getAll();
      } catch (err) {
        this.loadingUsers = false;
      }
      this.loadingUsers = false;
    },
  },
};
</script>
